import React from 'react';
import Style from './formPreview.module.css';
import { CheckboxLabel } from '@weezevent/nacre';

export default function FormCheckbox({ field, label, value = null, id = null, onChangeForm = () => {} }) {
    const checked = React.useMemo(() => {
        if (value === null || value === '') {
            //compatibility '0' | '1' | true | false
            return Boolean(Number(field.form_field.default_value));
        }
        //compatibility '0' | '1' | true | false
        return Boolean(Number(value));
    }, [value, field]);

    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
            }
        },
        [id]
    );

    return (
        <div className={Style['field']}>
            <CheckboxLabel label={label} required={field.required} checked={checked} onChange={(e, { checked }) => onChange(checked)} {...field} />
        </div>
    );
}
